/**
 * WbLabelStrip — kop van een stopkaart.
 *
 * Nummer in een 56 px vak, naam + WB-nummer, rechts het type-vak:
 * geel OPHALEN / groen AFLEVEREN (kleur = betekenis, zie tokens.md).
 */

import clsx from 'clsx';

export interface WbLabelStripProps {
  nummer: string | number;
  naam: string;
  /** Regel onder de naam, mono (WB-nummer, contactpersoon). */
  sub?: string;
  type: 'Ophalen' | 'Terugbrengen' | string | undefined;
  /** Mint markering: het nummer-vak licht op als dit de volgende stop is. */
  isNext?: boolean;
  className?: string;
}

export function typeLabel(type: string | undefined): string {
  if (type === 'Ophalen') return 'Ophalen';
  if (type === 'Terugbrengen') return 'Afleveren';
  return type ?? '';
}

export function WbLabelStrip({ nummer, naam, sub, type, isNext = false, className }: WbLabelStripProps) {
  const isOphalen = type === 'Ophalen';
  return (
    <div className={clsx('flex items-stretch border-b-wb border-wb-rand', className)}>
      <div
        className={clsx(
          'w-14 shrink-0 flex items-center justify-center font-wb-heading font-bold text-2xl border-r-wb border-wb-rand',
          isNext ? 'bg-wb-mint text-wb-mintink' : 'bg-wb-inkt text-white'
        )}
      >
        {nummer}
      </div>
      <div className="flex-1 min-w-0 px-3 py-2">
        <p className="font-wb-heading font-bold text-xl leading-tight text-wb-inkt truncate">{naam}</p>
        {sub && <p className="font-mono text-sm text-wb-inkt2 truncate">{sub}</p>}
      </div>
      <div
        className={clsx(
          'shrink-0 flex items-center px-3 font-wb-heading font-bold text-sm uppercase tracking-wide border-l-wb border-wb-rand text-wb-inkt',
          isOphalen ? 'bg-wb-ophalen' : 'bg-wb-afleveren'
        )}
      >
        {typeLabel(type)}
      </div>
    </div>
  );
}
